"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _utils = require("egov-ui-framework/ui-config/screens/specs/utils");

var _commons = require("egov-ui-framework/ui-utils/commons.js");

var _actions = require("egov-ui-kit/redux/form/actions");

var _actions2 = require("egov-ui-framework/ui-redux/screen-configuration/actions");

var _get = require("lodash/get");

var _get2 = _interopRequireDefault(_get);

var _set = require("lodash/set");

var _set2 = _interopRequireDefault(_set);

var _enableDependentFields = require("./utils/enableDependentFields");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var formConfig = {
  name: "ownerInfo",
  fields: {
    name: {
      id: "name",
      jsonPath: "Properties[0].owners[0].name",
      type: "textfield",
      floatingLabelText: "Owner Name",
      hintText: "",
      required: true,
      errorStyle: { position: "absolute", bottom: -8, zIndex: 5 },
      pattern: (0, _utils.getPattern)("Name"),
      errorMessage: "required!"
    },
    gender: {
      id: "gender",
      jsonPath: "Properties[0].owners[0].gender"
    }
  },
  //   beforeInitForm: (action, store, dispatch) => {
  //     try {
  //       let state = store.getState();

  //       const OwnerTypes = get(state, `common.generalMDMSDataById.OwnerType`);
  //       dropdownData &&
  //         dropdownData.length > 0 &&
  //         dropdownData.forEach((data) => {
  //           data.label = getLocaleLabels(`COMMON_MASTERS_OWNERTYPE_${data.value}`, `COMMON_MASTERS_OWNERTYPE_${data.value}`);
  //         });

  //       //  set(action, "form.fields.ownerCategory.dropDownData", dropdownData);
  //       const ownerShipType = get(state, "form.ownershipType.fields.typeOfOwnership.value", "");
  //       if (ownerShipType === "SINGLEOWNER") {
  //         set(action, "form.fields.ownerGender.value", get(state, "form.ownerInfo.fields.ownerGender.value", "Male"));
  //       }

  //       return action;
  //     } catch (e) {
  //       return action;
  //     }
  //   },
  //   afterInitForm: (action, store, dispatch) => {
  //     // set the form
  //     const setFields = () => {
  //       // dispatch for inspection form
  //       function getParameterByName(name, url = window.location.href) {
  //         name = name.replace(/[\[\]]/g, "\\$&");
  //         var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
  //           results = regex.exec(url);
  //         if (!results) return null;
  //         if (!results[2]) return "";
  //         return decodeURIComponent(results[2].replace(/\+/g, " "));
  //       }

  //       const urlParams = getParameterByName("isInspection");

  //       if (urlParams == "yes") {
  //         let state = store.getState();
  //         let data = get(state.screenConfiguration.preparedFinalObject, "Properties");

  //         if (data && data.length > 0) {
  //           if (data[0].owners.length > 0) {
  //             let ownerInfo = data[0].owners[0];
  //             dispatch(setFieldProperty("ownerInfo", "ownerName", "value", ownerInfo.name || ""));
  //             dispatch(setFieldProperty("ownerInfo", "ownerGender", "value", ownerInfo.gender || ""));

  //             dispatch(prepareFinalObject("Properties[0].owners[0].name", ownerInfo.name || ""));
  //             dispatch(prepareFinalObject("Properties[0].owners[0].gender", ownerInfo.gender || ""));
  //           }
  //         }
  //       }
  //     };

  //     try {
  //       const formKey = get(action, "form.name", "");
  //       const state = store.getState();
  //       const currentOwnershipTypeNew = get(state, "form.ownershipType.fields.ownerShipType.value", "");
  //       let formData = get(state, "form", {});
  //       let count = 0;
  //       for (let [key, value] of Object.entries(formData)) {
  //         if (key.indexOf("ownerInfo") !== -1) count = count + 1;
  //       }
  //       if (count !== 1 && count !== 0) {
  //         // if (currentOwnershipTypeNew === "Owner Available") {
  //         //   dispatch(setFieldProperty(`ownerInfo_${count - 1}`, "ownerName", "required", true));
  //         //   dispatch(setFieldProperty(`ownerInfo_${count - 1}`, "ownerMobile", "required", true));
  //         //   dispatch(setFieldProperty(`ownerInfo_${count - 1}`, "ownerGuardian", "required", true));
  //         // } else {
  //         //   dispatch(setFieldProperty(`ownerInfo_${count - 1}`, "ownerName", "required", false));
  //         //   dispatch(setFieldProperty(`ownerInfo_${count - 1}`, "ownerMobile", "required", false));
  //         //   dispatch(setFieldProperty(`ownerInfo_${count - 1}`, "ownerGuardian", "required", false));
  //         // }
  //       }
  //       if (get(state, `form.${formKey}.fields.ownerRelationship.value`, "NONE") === "NONE") {
  //         dispatch(handleFieldChange(formKey, "ownerRelationship", "FATHER"));
  //       }
  //       //   if (get(state, `form.${formKey}.fields.ownerCategory.value`, "NONE") === "NONE") {
  //       //     dispatch(setFieldProperty(formKey, "ownerCategoryId", "hideField", true));
  //       //     dispatch(setFieldProperty(formKey, "ownerCategoryIdType", "hideField", true));
  //       //   } else {
  //       //     dispatch(setFieldProperty(formKey, "ownerCategoryId", "hideField", false));
  //       //     dispatch(setFieldProperty(formKey, "ownerCategoryIdType", "hideField", false));
  //       //   }
  //       //   const currentCategory = get(state, `form.${action.form.name}.fields.ownerCategory.value`, "NONE");
  //       let documentTypes = get(
  //         state,
  //         `${process.env.REACT_APP_NAME === "Citizen" ? "citizen" : "employee"}.mdms.document.MdmsRes.PropertyTax.OwnerTypeDocument`,
  //         []
  //       )
  //         .filter((docu) => {
  //           return docu.ownerTypeCode === currentCategory;
  //         })
  //         .reduce((acc, curr) => {
  //           let currAcc = [...acc];
  //           let dropDownData = {
  //             label: curr.name,
  //             value: curr.code,
  //           };
  //           currAcc.push(dropDownData);
  //           return currAcc;
  //         }, []);

  //       documentTypes &&
  //         documentTypes.length > 0 &&
  //         documentTypes.forEach((data) => {
  //           data.label = getLocaleLabels(`PROPERTYTAX_OWNERTYPEDOCUMENT_${data.value}`, `PROPERTYTAX_OWNERTYPEDOCUMENT_${data.value}`);
  //         });
  //       dispatch(setFieldProperty(action.form.name, "ownerCategoryIdType", "dropDownData", documentTypes));
  //       dispatch(setFieldProperty("ownerInfo", "ownershipType", "value", "STATEGOVERNMENT"));
  //       dispatch(setFieldProperty("ownerInfo", "premisesType", "value", "STATEGOVERNMENT"));

  //       return action;
  //     } catch (e) {
  //       setFields();
  //       return action;
  //     }
  //   },
  action: "",
  redirectionRoute: "",
  saveUrl: "",
  isFormValid: false
};
exports.default = formConfig;


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/config/forms/specs/PropertyTaxPayForInspection/ownerInfo.js
// module id = 1883
// module chunks = 1137